var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 24.25,
  cy: 24.5,
  r: 23.5,
  fill: "white",
  stroke: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M24.2474 9.07153L24.0352 9.77473V30.1782L24.2474 30.3847L33.9574 24.7864L24.2474 9.07153Z",
  fill: "#343434"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M24.2454 9.07153L14.5352 24.7864L24.2454 30.3847V20.4814V9.07153Z",
  fill: "#8C8C8C"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M24.2485 32.1777L24.1289 32.32V39.588L24.2485 39.9286L33.9645 26.5823L24.2485 32.1777Z",
  fill: "#3C3C3B"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M24.2454 39.9286V32.1777L14.5352 26.5823L24.2454 39.9286Z",
  fill: "#8C8C8C"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M24.2441 30.3845L33.9542 24.7862L24.2441 20.4812V30.3845Z",
  fill: "#141414"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M14.5352 24.7862L24.2454 30.3845V20.4812L14.5352 24.7862Z",
  fill: "#393939"
});

function SvgEth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEth);
export default __webpack_public_path__ + "static/media/eth.05d35cab53f665ca81c0f81460d4355c.svg";
export { ForwardRef as ReactComponent };